import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSupport = () => {
  const [selectedContact, setSelectedContact] = useState(null);

  const contactMethods = [
    {
      id: 'phone',
      title: 'Phone Support',
      description: 'Speak directly with our support team',
      value: '+91 94545 88858',
      icon: 'Phone',
      color: 'text-success',
      available: '9 AM - 8 PM (Mon-Sat)',
      action: () => window.open('tel:+919454588858', '_self')
    },
    {
      id: 'email',
      title: 'Email Support',
      description: 'Send us your queries and concerns',
      value: 'solvarsity@solutioneers.in',
      icon: 'Mail',
      color: 'text-primary',
      available: '24/7 Response within 4 hours',
      action: () => window.open('mailto:solvarsity@solutioneers.in?subject=Registration Support - Query', '_blank')
    },
    {
      id: 'whatsapp',
      title: 'WhatsApp Support',
      description: 'Quick assistance via WhatsApp',
      value: '+91 94545 88858',
      icon: 'MessageCircle',
      color: 'text-green-600',
      available: '9 AM - 8 PM (Mon-Sat)',
      action: () => window.open('https://wa.me/919454588858?text=Hi, I need support regarding my Solvarsity registration', '_blank')
    },
    {
      id: 'chat',
      title: 'Live Chat',
      description: 'Instant chat with support agents',
      // value: 'Available on website',
      value: 'Now available on whatsapp',
      icon: 'MessageSquare',
      color: 'text-accent',
      available: '9 AM - 8 PM (Mon-Sat)',
      // action: () => window.open('https://trainingplus.com/chat', '_blank')
      action: () => window.open('https://wa.me/917376700783?text=Hi, I need support regarding my Solvarsity registration', '_blank')

    }
  ];

  const faqItems = [
    {
      question: 'When will I receive my login credentials?',
      answer: 'Login credentials for the learning portal will be sent to your registered email within 24 hours of successful payment.'
    },
    {
      question: 'Can I change my batch timing?',
      answer: 'Yes, you can request a batch change up to 48 hours before the program starts. Contact our support team for assistance.'
    },
    {
      question: 'What if I miss the orientation session?',
      answer: 'Don\'t worry! We record all orientation sessions. You\'ll receive the recording link and can schedule a one-on-one session with our team.'
    },
    {
      question: 'Is there a refund policy?',
      answer: 'We offer a full refund if you cancel within 48 hours of registration. After the program starts, refunds are processed as per our terms and conditions.'
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-xl p-6 mb-8">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="Headphones" size={20} color="var(--color-primary)" strokeWidth={2} />
        <h2 className="text-xl font-semibold text-foreground">
          Need Help? We're Here for You
        </h2>
      </div>

      {/* Contact Methods */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {contactMethods.map((method) => (
          <div
            key={method.id}
            className="p-4 border border-border rounded-lg hover:shadow-subtle transition-smooth cursor-pointer"
            onClick={() => setSelectedContact(selectedContact === method.id ? null : method.id)}
          >
            <div className="flex items-start space-x-3">
              <div className={`flex-shrink-0 mt-1 ${method.color}`}>
                <Icon name={method.icon} size={20} strokeWidth={2} />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-foreground mb-1">
                  {method.title}
                </h3>
                <p className="text-xs text-text-secondary mb-2">
                  {method.description}
                </p>
                <p className="text-xs font-medium text-foreground mb-1">
                  {method.value}
                </p>
                <p className="text-xs text-text-secondary">
                  {method.available}
                </p>
              </div>
              <div className="flex-shrink-0">
                <Icon 
                  name={selectedContact === method.id ? "ChevronUp" : "ChevronDown"} 
                  size={16} 
                  color="var(--color-text-secondary)" 
                  strokeWidth={2} 
                />
              </div>
            </div>

            {selectedContact === method.id && (
              <div className="mt-4 pt-4 border-t border-border">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    method.action();
                  }}
                  iconName="ExternalLink"
                  iconPosition="right"
                  fullWidth
                >
                  Contact via {method.title}
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Quick FAQ */}
      <div className="border-t border-border pt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Frequently Asked Questions
        </h3>
        <div className="space-y-4">
          {faqItems.map((faq, index) => (
            <div key={index} className="p-4 bg-muted/30 rounded-lg">
              <h4 className="text-sm font-semibold text-foreground mb-2">
                {faq.question}
              </h4>
              <p className="text-xs text-text-secondary">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Emergency Contact */}
      <div className="mt-6 p-4 bg-destructive/5 border border-destructive/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="AlertTriangle" size={18} color="var(--color-destructive)" strokeWidth={2} />
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-1">
              Emergency Support
            </h3>
            <p className="text-xs text-text-secondary mb-2">
              For urgent technical issues during live sessions or critical support needs:
            </p>
            <a
              href="tel:+919876543210"
              className="text-xs font-medium text-destructive hover:text-destructive/80 transition-smooth"
            >
              📞 Emergency Hotline: +91 73767 00783
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;